import { css } from 'styled-components';
import { breakpoints } from './breakpoints';
export const elements = css `
  :root {
    font-size: 16px;
  }

  body {
    font-family: 'Charlie Text', sans-serif;
    font-size: 20px;
    min-height: 100vh;
    &.prevent-scroll {
      overflow: hidden;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-family: 'Charlie Display', sans-serif;
    font-weight: 500;
  }

  h1 {
    font-size: 2rem;
    line-height: 1.25;
  }
  h2 {
    font-size: 1.5rem;
    line-height: 1.33333333;
  }
  h3 {
    font-size: 1.25rem;
    line-height: 1.2;
  }
  h4 {
    font-size: 1rem;
    line-height: 1.25;
  }
  h5 {
    font-size: 1rem;
    line-height: 1.25;
    text-transform: uppercase;
  }

  @media (min-width: ${breakpoints.md}px) {
    h1 {
      font-size: 2.75rem;
      line-height: 1.18181818;
    }
    h2 {
      font-size: 2.25rem;
      line-height: 1.33333333;
    }
    h3 {
      font-size: 1.5rem;
      line-height: 1.33333333;
    }
    h4 {
      font-size: 1.25rem;
      line-height: 1.2;
    }
  }

  @media (min-width: ${breakpoints.lg}px) {
    h1 {
      font-size: 3rem;
      line-height: 1.25;
    }
  }

  p {
    margin-bottom: 1.5rem;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;
//# sourceMappingURL=elements.js.map